import { useEffect, useRef } from 'react';
import { Animated } from 'react-native';

export function useTutorialEntrance(isActive: boolean, delayMs: number) {
  const opacity = useRef(new Animated.Value(0)).current;
  const scale = useRef(new Animated.Value(0.92)).current;

  useEffect(() => {
    if (!isActive) {
      opacity.setValue(0);
      scale.setValue(0.92);
      return;
    }

    opacity.setValue(0);
    scale.setValue(0.92);

    const anim = Animated.sequence([
      Animated.delay(delayMs),
      Animated.parallel([
        Animated.timing(opacity, {
          toValue: 1,
          duration: 480,
          useNativeDriver: true,
        }),
        Animated.spring(scale, {
          toValue: 1,
          friction: 7,
          tension: 78,
          useNativeDriver: true,
        }),
      ]),
    ]);

    anim.start();
    return () => {
      anim.stop();
    };
  }, [isActive, delayMs, opacity, scale]);

  return { opacity, scale };
}
